import { Fragment, useContext, useState, useRef } from "react"
import style from "./CalendarBotev.Module.css"
import { January } from "./2026/January.js"
import { February } from "./2026/February"
import { March } from "./2026/March"
import { April } from "./2026/April"
import { May } from "./2026/May"
import { June } from "./2026/June"
import { July } from "./2026/July"
import { August } from "./2026/August"
import { September } from "./2026/September"
import { October } from "./2026/October"
import { November } from "./2026/November"
import { December } from "./2026/December"
import { LangContext } from "../../../contexts/Language.js";

const monthEn = ["January", "February", "March",
    "April", "May", "June", "July", "August", "September",
    "October", "November", "December"];

const monthBg = ['Януари', 'Февруари', 'Март', 'Април', 'Май',
    'Юни', 'Юли', 'Август', 'Септември', 'Октомври',
    'Ноември', 'Декември']

const monthCz = ['Leden', 'Únor', 'Březen', 'Duben', 'Květen',
    'Červen', 'Červenec', 'Srpen', 'Září', 'Říjen',
    'Listopad', 'Prosinec']

const monthRu = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май',
    'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь',
    'Ноябрь', 'Декабрь']


export const CalendarBotev = () => {
    const { lang } = useContext(LangContext);

    let date = new Date();
    let year = date.getFullYear();
    const [curMonth, setCurMonth] = useState(date.getMonth());
    const touchStartX = useRef(null);

    const goPrev = (curMonth) => {
        if (curMonth === 0) {
            setCurMonth(11);
        } else {
            setCurMonth(curMonth - 1);
        }
    };

    const goNext = (curMonth) => {
        if (curMonth === 11) {
            setCurMonth(0);
        } else {
            setCurMonth(curMonth + 1);
        }
    }

    const onTouchStart = (e) => { touchStartX.current = e.touches[0].clientX; };
    const onTouchEnd = (e) => {
        if (touchStartX.current === null) return;
        const diff = touchStartX.current - e.changedTouches[0].clientX;
        if (diff > 50) goNext(curMonth);
        else if (diff < -50) goPrev(curMonth);
        touchStartX.current = null;
    };

    return (
        <section className="calendar" onTouchStart={onTouchStart} onTouchEnd={onTouchEnd}>
            <ul className="month">
                <li onClick={() => goPrev(curMonth)} className="prev">&#10094;</li>
                {lang === 'EN' && <li>{monthEn[curMonth]} - {year}</li>}
                {lang === 'BG' && <li>{monthBg[curMonth]} - {year}</li>}
                {lang === 'CZ' && <li>{monthCz[curMonth]} - {year}</li>}
                {lang === 'RU' && <li>{monthRu[curMonth]} - {year}</li>}              
                <li onClick={() => goNext(curMonth)} className="next">&#10095;</li>
            </ul>
            <ul className="days">
                {lang === 'EN' && <section>
                    <li>Mon</li>
                    <li>Tue</li>
                    <li>Wed</li>
                    <li>Thu</li>
                    <li>Fri</li>
                    <li>Sat</li>
                    <li>Sun</li>
                </section>}
                {lang === 'BG' && <section>
                    <li>Пон</li>
                    <li>Вт</li>
                    <li>Ср</li>
                    <li>Чет</li>
                    <li>Пет</li>
                    <li>Съб</li>
                    <li>Нед</li>
                </section>}
                {lang === 'CZ' && <section>
                    <li>Po</li>
                    <li>Út</li>
                    <li>St</li>
                    <li>Čt</li>
                    <li>Pá</li>
                    <li>So</li>
                    <li>Ne</li>
                </section>}
                {lang === 'RU' && <section>
                    <li>Пн</li>
                    <li>Вт</li>
                    <li>Ср</li>
                    <li>Чт</li>
                    <li>Пт</li>
                    <li>Сб</li>
                    <li>Вс</li>
                </section>}

                {curMonth === 0 && <January />}
                {curMonth === 1 && <February />}
                {curMonth === 2 && <March />}
                {curMonth === 3 && <April />}
                {curMonth === 4 && <May />}
                {curMonth === 5 && <June />}
                {curMonth === 6 && <July />}
                {curMonth === 7 && <August />}
                {curMonth === 8 && <September />}
                {curMonth === 9 && <October />}
                {curMonth === 10 && <November />}
                {curMonth === 11 && <December />}
                {lang === 'BG' && <p className="agenda">В червено са отбелязани дните, в които апартамента е зает!</p>}
                {lang === 'EN' && <p className="agenda">The days when the apartment is occupied are marked in red!</p>}
                {lang === 'CZ' && <p className="agenda">Dny, kdy je apartmán obsazen, jsou označeny červeně!</p>}
                {lang === 'RU' && <p className="agenda">Дни, когда апартамент занят, отмечены красным!</p>}
            </ul>
        </section>
    );
};